module.exports = __webpack_public_path__ + "img/icon-close.7784e85f.svg";